@let _ = artwork.value();
@if (_) {
  <div *transloco="let t" class="p-10 flex gap-4 flex-col overflow-auto">
    <div class="font-bold text-2xl flex justify-between">
      <div>
        {{t('evaluations.ourAnswer')}}
      </div>
      <div class="text-sm">
        <button wunButton primary (click)="downloadReport()">{{t('evaluations.downloadReport')}}</button>
      </div>

    </div>
    <div class="font-thin text-sm">
      {{_.description}}
    </div>
    @if(_.evaluation?.status === 'ACCEPTED'){
      <div class="font-thin text-2xl">
        {{t('evaluations.evaluationAcceptedFeedback')}}
      </div>
    }
    @if(_.evaluation?.status === 'REJECTED'){
      <div class="font-thin text-2xl">
        {{t('evaluations.evaluationRejectedFeedback')}}
      </div>
    }

    <div class="flex">
      <wun-media-render class="w-96 block" [media]="_.mainAttachment!" />
      <div class="flex flex-col justify-center gap-12">
        <div class="flex gap-2 flex-col">
          <div class="text-2xl font-bold">
            {{t('evaluations.estimateIs')}}
          </div>
          <div class="text-3xl font-bold">{{_.price | currency : 'EUR' : '' : '1.2-2' }} €</div>
        </div>

        @if (_.evaluation?.status === 'EVALUATED') {
          <div class="flex gap-4">
            <button wunButton primary (click)="acceptEvaluation()">{{t('common.accept')}}</button>
            <button wunButton danger (click)="rejectEvaluation()">{{t('common.reject')}}</button>
          </div>
        }
      </div>
    </div>
  </div>
}
